import React from 'react';

export const Return = () => (
    <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.11 9.99">
        <g>
            <path d="M8.17,4.1h-3.64V1.89L1.25,4.47V0H0V9.99H1.25V4.99l3.28,2.58v-2.21h3.64c.93,0,1.69,.76,1.69,1.69s-.76,1.69-1.69,1.69h-1v1.25h1c1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94Z"/>
        </g>
    </svg>
);
